var Handlebars = require('/home/runner/_work/basesite/basesite/packages/milb-site-core/node_modules/handlebars/dist/amd/handlebars.runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"headerConfig") : depth0)) != null ? lookupProperty(stack1,"ppSponsorURL") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":4,"column":2},"end":{"line":8,"column":9}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <a href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"headerConfig") : depth0)) != null ? lookupProperty(stack1,"ppSponsorURL") : stack1), depth0))
    + "\" class=\"mlb-scores__minisb-logos--sponsorship-logo\" target=\"_blank\"></a>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "  <span class=\"mlb-scores__minisb-logos--sponsorship-logo\"></span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"mlb-scores__minisb-logos "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"headerConfig") : depth0)) != null ? lookupProperty(stack1,"className") : stack1), depth0))
    + "\">\n  <span class=\"mlb-scores__minisb-logos--postseason-push-logo\"></span>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"headerConfig") : depth0)) != null ? lookupProperty(stack1,"showPostseasonPushSponsorLogo") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":9,"column":9}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});